import { __rest } from "tslib";
import { isProduction } from '../environment';
import { VEND_NS } from '../data/vendNamespace';
import { camelToSnake } from '../utilities/case';
import { Deferred } from '../utilities/deferred';
const TRACKING_API = 'https://track.api.vendhq.com/';
const COMPULSORY_TRACKER_PROPERTIES = [
    'domainPrefix',
    'retailerId',
    'systemName',
    'systemVersion',
    'userId',
];
// Create the deferred for the UBEConfig if it doesn't already exist on the window (i.e. created by another script)
if (!VEND_NS.ubeConfigDeferred) {
    VEND_NS.ubeConfigDeferred = new Deferred();
}
/**
 * Configure UBE tracking by with the given UBEConfig. UBE events will be queued up until a minimum of the following
 * config properties are set: domainPrefix, retailerId, systemName, systemVersion and userId.
 */
export function configureUbeTracking(config) {
    VEND_NS.ubeConfig = Object.assign(Object.assign({}, VEND_NS.ubeConfig), config);
    if (COMPULSORY_TRACKER_PROPERTIES.every(prop => VEND_NS.ubeConfig[prop])) {
        VEND_NS.ubeConfigDeferred.resolve();
    }
    return VEND_NS.ubeConfigDeferred.promise;
}
async function getUbeConfig() {
    // Wait until the minimum required configuration has been supplied before proceeding
    await VEND_NS.ubeConfigDeferred.promise;
    return VEND_NS.ubeConfig;
}
/**
 * Sends a User Behaviour Event (UBE) to the event tracking API.
 */
export async function trackUserEvent(moduleName, eventName, metadata, options) {
    const _a = await getUbeConfig(), { environment } = _a, eventConfig = __rest(_a, ["environment"]);
    const event = Object.assign(Object.assign({}, eventConfig), { eventName, metadata: Object.assign({ location: window.location.pathname }, metadata), moduleName, timestamp: Date.now() });
    if (isProduction(window.location.href, environment)) {
        return _sendTrackingData(event, options);
    }
    else {
        // eslint-disable-next-line no-console
        console.info('[Tracking Vend Event]', camelToSnake(event, options === null || options === void 0 ? void 0 : options.depth));
        return Promise.resolve();
    }
}
function _sendTrackingData(event, options) {
    const body = JSON.stringify(camelToSnake(event, options === null || options === void 0 ? void 0 : options.depth));
    if ((options === null || options === void 0 ? void 0 : options.useSendBeacon) && window.navigator.sendBeacon) {
        const beaconBlob = new Blob([body], { type: 'text/plain' });
        return Promise.resolve(window.navigator.sendBeacon(TRACKING_API, beaconBlob));
    }
    return fetch(TRACKING_API, {
        body,
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
        },
        method: 'POST',
    });
}
